export default __webpack_public_path__ + "static/coperta-campanii-57e6f8557512a70a526e9ad01c85c143.jpg";